<template>
  <div class="container">
    <img :src="img" style="width: 100%" @click="preview()" alt="" />
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  name: "zhengshudetail",
  data() {
    return {
      img: "",
    };
  },
  created() {
    this.img = localStorage.getItem("zsimg");
  },
  methods: {
    preview() {
      ImagePreview([this.img]);
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/zhengshudetail.vue